import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_DmasCsReferralForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_DmasCsReferralForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>The Department of Medical Assistance Services <br />
                    Community Stabilization (S9482) Referral Form</h3></center> <br />
                    <center><h4><b>MEMBER INFORMATION</b></h4></center></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member First Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberFirstName' name='txtMemberFirstName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberLastName' name='txtMemberLastName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Date of Birth:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDateOfBirth' name='txtMemberDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male&nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Plan ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPlanId' name='txtMemberPlanId' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberAddress' name='txtMemberAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>State:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Zip:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPhone' name='txtMemberPhone' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Name(if applicable):</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian Phone # (if applicable):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardian' name='txtParentGuardian' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtParentPhone' name='txtParentPhone' className='add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><center><h4><b>REFERRING PROVIDER INFORMATION</b></h4></center></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtReferringOrganizationName' name='txtReferringOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtReferringProviderPhone' name='txtReferringProviderPhone' defaultValue={8047891314} className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Address:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Fax #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtReferringProviderEmail' name='txtReferringProviderEmail' placeholder='qualitycompliance@ey4pc.com' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtReferringProviderAddress' name='txtReferringProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtReferringProviderFax' name='txtReferringProviderFax' defaultValue={8044823767} className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtReferringCity' name='txtReferringCity' placeholder='Richmond' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtReferringState' name='txtReferringState' placeholder='Virginia' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtReferringZip' name='txtReferringZip' defaultValue={23224} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                        <td className='w-350'>
                            <span className='eleHeader'>Clinical Contact Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtReferringClinicalContactName' name='txtReferringClinicalContactName' placeholder='Ngozi Nwajiaku,LMHP-R, NCC, CSAC-SuperviseeReferring' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtReferringClinicalContactPhone' name='txtReferringClinicalContactPhone' defaultValue={8049653505} className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'><center><h4><b>COMMUNITY STABILIZATION PROVIDER</b></h4></center></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCommunityOrganizationName' name='txtCommunityOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtCommunityProviderPhone' name='txtCommunityProviderPhone' defaultValue={8047891314} className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Address:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Fax #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCommunityProviderEmail' name='txtCommunityProviderEmail' placeholder='qualitycompliance@ey4pc.com' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtCommunityProviderAddress' name='txtCommunityProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtCommunityProviderFax' name='txtCommunityProviderFax' defaultValue={8044823767} className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCommunityCity' name='txtCommunityCity' placeholder='Richmond' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtCommunityState' name='txtCommunityState' placeholder='Virginia' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtCommunityZip' name='txtCommunityZip' defaultValue={23224} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                        <td className='w-350'>
                            <span className='eleHeader'>Clinical Contact Phone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtCommunityClinicalContactName' name='txtCommunityClinicalContactName' placeholder='Ngozi Nwajiaku,LMHP-R, NCC, CSAC-SuperviseeReferring' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtCommunityClinicalContactPhone' name='txtCommunityClinicalContactPhone' defaultValue={8049653505} className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>REASON FOR REFERRAL</b></h4></center>
                    Date of Discharge/anticipated discharge &nbsp;
                    <input type='date' id='txtReasonForReferral' name='txtReasonForReferral' className='add-only w-200 custom-add-only' /> <br />
                    <textarea id='txtReasonForReferral_1' name='txtReasonForReferral_1' className='add-only'></textarea> <br /><br />

                    By my signature (below), I am attesting that 1) I have performed care coordination activities and collaborated with the Community Stabilization provider as
                    part of my discharge planning 2) the member is in need of Community Stabilization Services as part of a comprehensive discharge plan</p>


                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature of Appropriately Licensed Practitioner & Credentials </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Printed Name of referring provider:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Title:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrintedNameOfReferringProvider' name='txtPrintedNameOfReferringProvider' placeholder='Ngozi Nwajiaku' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtTitle' name='txtTitle' placeholder='LMHP-Resident in Counseling, CSAC-Supervisee' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Credentials (if applicable)</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCredentialsIfApplicable' name='txtCredentialsIfApplicable' placeholder='LMHP-R, NCC, CSAC-Supervisee' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                </table>
































            </div >
        </form >

    )
}











